import { ChevronUp, ChevronDown } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

const SECTION_LABEL_KEYS = {
  activity_ticker: "layout.activityTicker",
  banner_top: "layout.banner",
  stats: "layout.stats",
  rider_events: "events.riderEvents",
  map: "map.title",
  farli: "layout.farli",
  open_now: "layout.openNow",
  events: "layout.events",
  public_feed: "layout.feed",
  newsletter: "layout.newsletter",
  pitstop_cta: "layout.pitstopCta",
  overnight_free: "overnight.freeOvernight",
  overnight_paid: "overnight.paidOvernight",
  download_app: "layout.downloadApp",
};

export function SortableSection({ id, children, isEditing, onMoveUp, onMoveDown, isFirst, isLast }) {
  const { t } = useLanguage();

  if (!isEditing) {
    return <div>{children}</div>;
  }

  const label = t(SECTION_LABEL_KEYS[id]) || id;

  return (
    <div className="relative group/sortable">
      {/* Top arrow — move up */}
      {!isFirst && (
        <div className="flex justify-center -mb-3 relative z-40">
          <button
            onClick={onMoveUp}
            className="flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-emerald-500 text-black text-xs font-bold hover:bg-emerald-400 active:scale-95 transition-all shadow-lg"
            data-testid={`move-up-${id}`}
          >
            <ChevronUp className="w-4 h-4" />
            {t('layout.moveUp')}
          </button>
        </div>
      )}

      {/* Section with label and border */}
      <div className="ring-2 ring-emerald-500/30 ring-dashed rounded-2xl overflow-hidden relative shake-section">
        {/* Label badge */}
        <div className="absolute top-2 left-2 z-30 px-3 py-1 rounded-lg bg-emerald-500/90 text-black text-xs font-bold shadow-md">
          {label}
        </div>
        {children}
      </div>

      {/* Bottom arrow — move down */}
      {!isLast && (
        <div className="flex justify-center -mt-3 relative z-40">
          <button
            onClick={onMoveDown}
            className="flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-emerald-500 text-black text-xs font-bold hover:bg-emerald-400 active:scale-95 transition-all shadow-lg"
            data-testid={`move-down-${id}`}
          >
            <ChevronDown className="w-4 h-4" />
            {t('layout.moveDown')}
          </button>
        </div>
      )}
    </div>
  );
}
